import React from "react";
import PortfolioGallery from "./PortfolioGallery";

const Portfolio = () => {
  return (
    <div className="bg-slate-200 px-8 py-10 ">
      <div className="font-serif items-center text-center mt-5 mb-5">
        <h1 className="text-3xl font-bold  text-black">My Portfolio</h1>
        <p className="text-xl">
          Thanks for taking some time to visit Studio Juno's portfolio. Here you
          will be able <br /> to find my latest and favorite works.
        </p>
      </div>
      <div>
        <PortfolioGallery />
      </div>
    </div>
  );
};

export default Portfolio;
